import { demo } from 'page/catalog/store/CatalogStore'

const duration = 500

function px(value: number) {
  return value.toFixed(3) + 'px'
}

function getCx2(): number {
  const { stand } = demo.optional ?? {}
  const bound = document.body.getBoundingClientRect()
  if (stand) return bound.width / 2
  const widget = document.querySelector('.showoff-widget-border')?.getBoundingClientRect()
  if (!widget) return bound.width - 200
  return widget.left + widget.width / 2
}

function getCy2(): number {
  const bound = document.body.getBoundingClientRect()
  return bound.height - 40
}

export function animateItem(source: HTMLElement) {
  const rect = source.getBoundingClientRect()
  const element = source.cloneNode(true) as HTMLElement

  element.style.zIndex = '1'
  element.style.position = 'fixed'
  element.style.width = px(rect.width)
  element.style.height = px(rect.height)

  element.style.left = px(rect.left)
  element.style.top = px(rect.top)
  element.style.borderRadius = px(12)

  const w2 = rect.width / 2
  const h2 = rect.height / 2
  const cx = rect.left + w2
  const cy = rect.top + h2
  const dx = getCx2() - cx
  const dy = getCy2() - cy

  function tick(x: number) {
    const left = cx - w2 + dx * Math.pow(x, 0.7)
    const top = cy - h2 + dy * x * x
    const scale = 1 - x * x * x
    const opacity = 1 - x * x

    element.style.left = px(left)
    element.style.top = px(top)
    element.style.transform = `scale(${scale})`
    element.style.opacity = opacity.toFixed(3)
  }

  let start = 0

  function schedule() {
    requestAnimationFrame(() => {
      const time = Date.now() - start
      const x = Math.min(1, time / duration)

      tick(x)

      if (time < duration) schedule()
      else element.remove()
    })
  }

  requestAnimationFrame(() => {
    document.body.append(element)
    start = Date.now()
    schedule()
  })
}
